import TermsAndConditionsAccordion from "../TermsAndConditionsAccordion/TermsAndConditionsAccordion";
import styles from "./FeatureMessages.module.scss";

type Props = {
  /**
   * Feature messages
   */
  featureMessages: {
    description: string | null | undefined;
    updatedLinksDescription: string;
    terms: string;
  }[];
  /**
   * Hide border top
   */
  hideBorderTop?: boolean;
  /**
   * Updated links description
   */
  updatedLinksDescription?: string;
};

export const FeatureMessagesUI = ({
  featureMessages,
  hideBorderTop,
}: Props) => {
  const featureMessageWrapperClass = styles.promotionalFeatures;

  if (featureMessages.length === 0) {
    return null;
  }

  return (
    <ul
      className={`${featureMessageWrapperClass} ${
        hideBorderTop ? styles.hideBorderTop : ""
      }`}
      data-testid="product:feature-messages"
    >
      {featureMessages.map((message, idx) => {
        return (
          <li key={idx}>
            <div
              data-testid="product:feature-messages:description"
              dangerouslySetInnerHTML={{
                __html: message.description || "",
              }}
            />
            {message.terms && (
              <TermsAndConditionsAccordion
                terms={message.terms}
                isVersionTwoPromoDrawer={false}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};
